// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { Checkbox, TextField, Typography } from "@insite/mobius/index";
import Button from "@store/MobiusOverrides/Button/Button";
import { SignatureModel } from "@store/Framework/Store/Bunzl/Pages/Signature/SignatureReducer";
import {
    ButtonRow,
    EmailMeContainer,
    generateInputStyles,
    SignaturePadCard,
    Title,
} from "@store/Library/Components/Signature/SharedSignatureModalStyles";
import { SigningModalOverrides } from "@store/Library/Components/Signature/SigningModal";
import React from "react";
import styled from "styled-components";

interface SignatureDisplayProps {
    signatureData: SignatureModel;
    signingModalOverrides?: SigningModalOverrides;
    onClose: () => void;
}

const SignatureDisplayContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const StyledImage = styled.img`
    width: 70%;
    height: 80%;
    display: flex;
    align-self: center;
    object-fit: contain;
`;

const DateTextDisplay = styled(Typography)`
    opacity: 0.9;
    align-self: flex-end;
    justify-self: flex-end;
`;

const SignatureReceiptDisplay: React.FC<SignatureDisplayProps> = ({
    signatureData,
    signingModalOverrides,
    onClose,
}) => {
    const dateSigned = new Date(signatureData.timestamp).toLocaleString();
    return (
        <>
            <Title style={{ textIndent: 0 }} variant="h5" className="signature-receipt-title">
                {translate(`I, `)} <Typography underline>{signatureData.customerName}</Typography>
                {translate(` hereby acknowledge that I have received the product(s) for this order. `)}
            </Title>
            <SignaturePadCard {...signingModalOverrides?.signaturePadCardProps}>
                <SignatureDisplayContainer>
                    <StyledImage
                        alt={`Signature of ${signatureData.customerName}`}
                        src={signatureData.customerSignature}
                        className="signature-receipt-image"
                    />
                    <DateTextDisplay className="signature-receipt-date">
                        {translate("Signed on:")} {dateSigned}
                    </DateTextDisplay>
                </SignatureDisplayContainer>
            </SignaturePadCard>

            {signatureData.customerEmail !== "" && (
                <EmailMeContainer
                    className="signature-editable-email-container"
                    {...signingModalOverrides?.emailMeContainerProps}
                >
                    <Checkbox
                        // @ts-ignore
                        iconProps={{ size: 18, style: { minWidth: 18 } }}
                        checked
                        disabled
                        className="signature-editable-email-checkbox"
                    >
                        {translate("I would like a copy emailed to me")}
                    </Checkbox>
                    <TextField
                        value={signatureData?.customerEmail}
                        placeholder="Email address"
                        disabled
                        {...generateInputStyles(true)}
                        {...signingModalOverrides?.emailInputProps}
                        className="signature-editable-email-input"
                    />
                </EmailMeContainer>
            )}
            <ButtonRow {...signingModalOverrides?.buttonRowProps}>
                <Button
                    onClick={onClose}
                    className="signature-receipt-close-button"
                    {...signingModalOverrides?.closeButtonProps}
                >
                    {translate("Close")}
                </Button>
            </ButtonRow>
        </>
    );
};

export default SignatureReceiptDisplay;
